import RecordingsPage from "@/pages/desktop/recordings-page";
import { Route } from "react-router-dom";

import DefaultLayout from "@/layouts/default-layout";
import MeetingsPage from "@/pages/meetings/meetings";
import MeetingDetailsPage from "@/pages/meetings/meeting-details-page";
import EditMeetingPage from "@/pages/meetings/edit-meeting-page";
import CreateMeetingPage from "@/pages/meetings/create-meeting-page";
import ActiveMeetingsPage from "@/pages/meetings/active-meetings-page";
import NetworkPage from "@/pages/network-page";
import ConnectionDetailsPage from "@/pages/connection-details-page";
import ProfilePage from "@/pages/v2/profile-page";

export function MobileRoutes() {
  return (
    <Route path="/">
      <Route element={<DefaultLayout />}>
        <Route index element={<MeetingsPage />} />
        <Route path="meetings" element={<MeetingsPage />} />
        <Route path="meetings/:tab_id" element={<MeetingsPage />} />
        <Route path="meetings/view/:short_code" element={<MeetingDetailsPage />} />
        <Route path="meetings/edit/:short_code" element={<EditMeetingPage />} />

        <Route path="network" element={<NetworkPage />} />
        <Route path="network/:id" element={<ConnectionDetailsPage />} />

        <Route path="profile" element={<ProfilePage />} />
        <Route path="recordings" element={<RecordingsPage />} />

        <Route path=":tab_id" element={<MeetingsPage />} />
      </Route>

      {/* Full-screen, no layout chrome */}
      <Route path="meetings/new" element={<CreateMeetingPage />} />
      <Route path="meetings/join/:short_code" element={<ActiveMeetingsPage />} />
    </Route>
  );
}